/**Dependencies */
import React, { useEffect, useState } from "react";

/**Components */
import { Row, Col, Card, Button, Modal } from "react-bootstrap";
import { CarouselCards } from "../components/CarouselCards";
import { BannerDudas } from "../components/BannerDudas";

/**Styles */
import "../styles/transportation.scss";

/**Images */
import bannerRentaAutos from "../images2/Banner-renta-autos2.png";
import bannerReservaAuto1 from "../images2/banner-reserva-auto-1.png";
import bannerReservaAuto2 from "../images2/banner-reserva-auto-2.png";
import bannerReservaAuto3 from "../images2/banner-reserva-auto-3.png";
import bannerReservaAuto4 from "../images2/banner-reserva-auto-4.png";
import BannerNecesitasAyuda from "../images2/Banner-contacto-renta-autos.png";
import BannerNecesitasAyudaMovil from "../images2/Banner-contacto-renta-autos-movil.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { IoMdPerson } from "react-icons/io";
import { FaBagShopping } from "react-icons/fa6";
import { TbManualGearbox } from "react-icons/tb";

import { getCollections } from "../services/CollectionsService";
import { getAutos } from "../services/rentaAutosService";
import { Currency } from "../helpers";
import { FaDollarSign } from "react-icons/fa";
import { GeneralForm } from "../components/GeneralForm";
import { Autoplay } from "swiper/modules";

export const RentaAutos = () => {
  const [collections, setCollections] = useState([]);
  const [autos, setAutos] = useState([]);
  const [show, setShow] = useState(false);
  const [modalAuto, setModalAuto] = useState([]);
  useEffect(() => {
    const obtenerCollections = async () => {
      try {
        const response = await getCollections();
        setCollections(response);
      } catch (error) {
        throw new Error("Error fetching Data. Collections: " + error);
      }
    };
    obtenerCollections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const obtenerAutos = async () => {
      try {
        const response = await getAutos();
        setAutos(response);
      } catch (error) {
        throw new Error("Error fetching Data. Autos: " + error);
      }
    };
    obtenerAutos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <div className="section-card container py-4">
        <div className="d-flex flex-column flex-lg-row flex-sm-row border-top align-items-center justify-content-center border-1 border-black">
          <div className="banner-carros py-5 text-center text-lg-start">
            <h1 className="border-2 pt-4 banner-carros title-cars">
              Siente la libertad, <br />
              <span className="banner-carros title-cars libertad">
                Conduce tu camino
              </span>
            </h1>
          </div>
          <div className="py-5 w-100">
            <img src={bannerRentaAutos} alt="" className="w-100" />
          </div>
        </div>
      </div>

      <div className="section-card container-lg ps-0 pe-0 ps-lg-1 pe-lg-1 py-0 py-sm-2 py-lg-5">
        <h1 className="text-center fw-semibold pb-5">
          Reserva tu auto ideal y maneja tu itinerario sin contratiempos
        </h1>
        <div>
          <div className="d-flex w-100 justify-content-center">
            <div className="p-lg-3">
              <img
                src={bannerReservaAuto1}
                alt=""
                className="gallery-cars shadow"
              />
            </div>
            <div className="p-lg-3">
              <img
                src={bannerReservaAuto2}
                alt=""
                className="gallery-cars shadow"
              />
            </div>
            <div className="p-lg-3">
              <img
                src={bannerReservaAuto3}
                alt=""
                className="gallery-cars shadow"
              />
            </div>
            <div className="p-lg-3">
              <img
                src={bannerReservaAuto4}
                alt=""
                className="gallery-cars shadow"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="section-list-vehicules py-5">
        <div className="container">
          <div
          /* pagination={{
              clickable: true,
            }}
            modules={[Autoplay]}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            //direction={"vertical"}
            // spaceBetween={100}
            breakpoints={{
              300: {
                slidesPerView: 1,
              },
              1024: {
                slidesPerView: 1,
              },
              1400: {
                slidesPerView: 1,
              },
            }}
            className="swiper" */
          >
            {autos.map((infoVehicules, index) => (
              <div key={index + 1}>
                <div className="cards-hotels container py-3">
                  <Card
                    className={
                      "shadow rounded-5 border-0 " +
                      (infoVehicules?.destacado === 0 ? "" : "destacado")
                    }
                  >
                    <Row>
                      <Col lg={4} md={12} sm={12}>
                        <div className="p-2 pb-0 d-lg-flex d-none justify-content-center font-weight-bold">
                          <h4
                            className={
                              "fw-semibold " +
                              (infoVehicules?.destacado === 0
                                ? "text-dark"
                                : "text-light")
                            }
                            style={{ margin: "0" }}
                          >
                            {infoVehicules?.titulo} <br />{" "}
                            <span style={{ fontSize: "17px" }}>
                              {" "}
                              {infoVehicules?.name_auto}{" "}
                            </span>{" "}
                          </h4>
                        </div>
                        <div className="w-100 d-lg-none d-flex p-3 justify-content-end">
                          <img
                            src={
                              "https://panel.marzahtravel.com/assets/uploads/rentaAutos/autos/" +
                              infoVehicules?.logo_rental_car
                            }
                            className="pb-2"
                            alt=""
                            width={65}
                          />
                        </div>
                        <img
                          src={
                            "https://panel.marzahtravel.com/assets/uploads/rentaAutos/autos/" +
                            infoVehicules?.image_auto
                          }
                          alt=""
                          style={{
                            width: "50%",
                            height: "auto",
                            paddingLeft: "1rem",
                            paddingRight: "1rem",
                            marginLeft: "100px",
                            display: "block",
                          }}
                        />
                        <div className="p-2 pb-0 d-lg-none d-flex justify-content-center font-weight-bold">
                          <h4
                            className={
                              "fw-semibold " +
                              (infoVehicules?.destacado === 0
                                ? "text-dark"
                                : "text-light")
                            }
                            style={{ margin: "0" }}
                          >
                            {infoVehicules?.titulo} <br />{" "}
                            <span style={{ fontSize: "17px" }}>
                              {" "}
                              {infoVehicules?.name_auto}{" "}
                            </span>{" "}
                          </h4>
                        </div>
                      </Col>
                      <Col lg={3} md={12} sm={12}>
                        <div
                          className="amenities d-grid pt-4"
                          style={{ marginLeft: "40px" }}
                        >
                          <p
                            className={
                              "m-0 " +
                              (infoVehicules?.destacado === 0
                                ? " text-dark"
                                : " text-light")
                            }
                            style={{ fontSize: "20px" }}
                          >
                            <FaDollarSign
                              className={
                                "details-cars " +
                                (infoVehicules?.destacado === 0
                                  ? "text-destacado"
                                  : "text-light")
                              }
                            />
                            {Currency(infoVehicules?.price).replace("$", "")}{" "}
                            <span style={{ fontSize: "15px" }}>MXN</span> por
                            día
                          </p>
                          <span
                            className={
                              infoVehicules?.destacado === 0
                                ? "text-dark"
                                : "text-light"
                            }
                          >
                            <IoMdPerson
                              className={
                                "details-cars " +
                                (infoVehicules?.destacado === 0
                                  ? "text-destacado"
                                  : "text-light")
                              }
                            />{" "}
                            {infoVehicules?.total_passengers}
                          </span>
                          <span
                            className={
                              infoVehicules?.destacado === 0
                                ? "text-dark"
                                : "text-light"
                            }
                            style={{ marginTop: "10px" }}
                          >
                            <FaBagShopping
                              className={
                                "details-cars " +
                                (infoVehicules?.destacado === 0
                                  ? "text-destacado"
                                  : "text-light")
                              }
                            />{" "}
                            {infoVehicules?.total_luggage} maletas{" "}
                          </span>
                          <span
                            className={
                              infoVehicules?.destacado === 0
                                ? "text-dark"
                                : "text-light"
                            }
                            style={{ marginTop: "10px" }}
                          >
                            <TbManualGearbox
                              className={
                                "details-cars " +
                                (infoVehicules?.destacado === 0
                                  ? "text-destacado"
                                  : "text-light")
                              }
                            />
                            {infoVehicules?.type_car}{" "}
                          </span>
                          <br />
                          {/*   <span className="d-none d-lg-flex">
                            <img
                              src={
                                "https://panel.marzahtravel.com/assets/uploads/rentaAutos/autos/" +
                                infoVehicules?.logo_rental_car
                              }
                              className="pb-2"
                              alt=""
                            />
                          </span> */}
                        </div>
                      </Col>
                      <Col lg={5} md={12} sm={12}>
                        <div
                          style={{
                            marginRight: "30px",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <div className="py-4 d-grid justify-content-evenly w-100 h-100 align-items-center">
                            <span className="d-none d-lg-flex">
                              <img
                                src={
                                  "https://panel.marzahtravel.com/assets/uploads/rentaAutos/autos/" +
                                  infoVehicules?.logo_rental_car
                                }
                                className="pb-2 px-4"
                                alt=""
                              />
                            </span>
                            <div className="mt-lg-0 mt-4">
                              <Button
                                onClick={() => [
                                  handleShow(),
                                  setModalAuto(infoVehicules),
                                ]}
                                className={
                                  "p-3 bg-transparent border-2 rounded-5 " +
                                  (infoVehicules?.destacado === 0
                                    ? "text-dark"
                                    : "text-light")
                                }
                                style={{
                                  borderColor: "#6e8dc1",
                                  width: "10rem",
                                }}
                              >
                                Cotízar
                              </Button>
                            </div>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <Modal show={show} centered onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Contáctanos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <GeneralForm
            urlSection={"/renta-autos"}
            isContactForm={false}
            isRentalCarForm={true}
            data={modalAuto}
          />
        </Modal.Body>
      </Modal>

      <div className="py-2 py-sm-2 py-lg-5">
        <BannerDudas
          imgDudasDesk={BannerNecesitasAyuda}
          imgDudasMovil={BannerNecesitasAyudaMovil}
          bannerDudas={true}
        />
      </div>

      <div className="py-2 py-sm-2 py-lg-2">
        <CarouselCards
          title={"Encuentra más colecciones aquí"}
          cardsInfo={collections}
          seccion={"collections"}
        />{" "}
      </div>
    </div>
  );
};
